import Image from 'next/image'
import { RecentSearchesProps } from '@interfaces/header'
import { Button } from '@components/Ackodrive/Button'
import { SEARCH } from '../constants/icons'
import styles from './SearchComponent.module.scss'

const RecentSearches = ({ recentSearches, onRecentSearchClick, searchQuery, variant }: RecentSearchesProps) => {
  if (recentSearches.length === 0 || searchQuery.trim()) {
    return null
  }

  return (
    <div className={styles.recentSearchContainer}>
      <p className={styles.recentSearchTitle}>Your recent searches</p>
      <div className={styles.recentSearchTags}>
        {recentSearches?.map((search, index) => (
          <Button
            key={index}
            className={styles.recentSearchTag}
            onClick={() => onRecentSearchClick(search.query, search.type)}>
            <Image
              src={SEARCH}
              alt="Search"
              width={16}
              height={16}
              className={styles.recentSearchIcon}
              loading="lazy"
            />
            {search.query}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default RecentSearches
